module.exports = __webpack_public_path__ + "static/media/disco-dude-footer.b2d5c0b0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/disco-dude-footer.svg
// module id = 152
// module chunks = 0